import { SlideHeader, Headline } from "../shared";

export function Slide08Pilot() {
  const QUESTIONS = [
    "Does wrist access change how often people reapply, compared with carrying a bottle?",
    "How much formulation do participants use each week?",
    "Do they keep wearing it after the first weeks?",
    "Do they buy refills?",
  ];
  return (
    <div className="max-w-3xl" data-testid="pitch-slide-pilot">
      <SlideHeader n="08" label="First Pilot" />
      <Headline>
        Start where application is <span className="text-accent">easy to measure.</span>
      </Headline>
      <div className="flex items-baseline gap-4 mt-5">
        <span className="font-heading text-4xl md:text-5xl font-light" style={{ color: "#ff2d78" }}>33%</span>
        <p className="font-body text-zinc-400 text-sm leading-relaxed max-w-xs">
          of U.S. adults typically reapply sunscreen every two hours as recommended.
          <br />
          <span className="text-zinc-600">Source: American Academy of Dermatology survey of 1,000 U.S. adults, 2021.</span>
        </p>
      </div>
      <p className="font-mono text-xs tracking-[0.2em] uppercase text-accent mt-6">The 200-Person Pilot Will Test</p>
      <div className="mt-3 space-y-2 max-w-2xl" data-testid="pitch-pilot-questions">
        {QUESTIONS.map((q) => (
          <div key={q} className="flex items-start gap-3">
            <span className="w-1.5 h-1.5 rounded-full bg-accent mt-2 shrink-0" />
            <p className="font-body text-zinc-300 text-sm md:text-base leading-relaxed">{q}</p>
          </div>
        ))}
      </div>
      <p className="font-body text-zinc-500 text-sm leading-relaxed mt-4 max-w-2xl">
        Proposed design: two groups of 100, wrist dispenser versus their usual bottle. Better
        adherence and higher product use are hypotheses to measure, not assumed results.
      </p>
    </div>
  );
}
